import React, { useEffect, useState, useRef } from "react";
import DatePicker from "react-mobile-datepicker-jalaali-persian";
import * as jalaali from "jalaali-js";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import SwipeableBottomSheet from "react-swipeable-bottom-sheet";
import { base_url } from "../../../Api/Api";
import { Loader } from "../../../Global/Loader";
import { Popup } from "../../../Global/Popup";

import Header from "../../../Global/Header";

const EditPersonalInfo = (props) => {
  const [time, setTime] = useState(
    jalaali.toJalaali(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDay()
    )
  );

  const [state, setState] = useState({
    data: [],
    popupStatus: false,
    popupType: 1,
    textApi: "",
    loader: true,
    statusBottomSheet: false,
    dropdownClass: false,
    imgPlaceholder: "",
    imgUrl: "",
    name: "",
    lastName: "",
    nationalCode: "",
    email: "",
    validInput: false,
    animToggle: true,
    statusdatepicker: false,
    dateValue: "",
  });

  useEffect(() => {
    base_url
      .get(`update_profile`)
      .then((response) => {
        console.log(response.data);
        setState({
          ...state,
          data: response.data,
          imgPlaceholder: response.data.profile_photo_url,
          name: response.data.name,
          lastName: response.data.last_name,
          nationalCode: response.data.national_code,
          dateValue: response.data.birthdate,
          email: response.data.email == null ? "" : response.data.email,
          dropdownClass: response.data.birthdate.length !== 0,
          animToggle: false,
          loader: false,
        });
      })
      .catch((error) => {
        if (error.response != undefined) {
          console.log(error);
          if (error.response.status == 401) {
            props.history.push(`/Entrance`);
          }
        }
      });
  }, []);

  useEffect(() => {
    if (document.getElementsByClassName("datepicker-modal")[0] !== undefined) {
      if (state.statusdatepicker) {
        document
          .getElementsByClassName("datepicker-modal")[0]
          .classList.add("active");
      } else {
        document
          .getElementsByClassName("datepicker-modal")[0]
          .classList.remove("active");
      }
    }
  }, [state.statusdatepicker]);

  const handleInput = (e, target) => {
    setState({
      ...state,
      [target]: e.target.value.trim().length == 0 ? "" : e.target.value,
    });
  };

  const loadFile = (event) => {
    var image = document.getElementById("output");
    image.src = URL.createObjectURL(event.target.files[0]);
    setState({
      ...state,
      imgUrl: image.src,
      statusBottomSheet: false,
    });
  };

  const deletePictuer = () => {
    var image = document.getElementById("output");
    image.src = "";
    setState({
      ...state,
      imgUrl: "",
      statusBottomSheet: false,
    });
  };

  // toggle bottom sheet
  const closeBottomSheet = () => {
    setState({
      ...state,
      statusBottomSheet: !state.statusBottomSheet,
    });
  };

  // toggle bottom sheet
  const toggleDatePicker = (isOpen) => {
    setState({
      ...state,
      statusdatepicker: !state.statusdatepicker,
      dropdownClass:
        state.dateValue.length == 0 ? !state.statusdatepicker : true,
    });
  };

  const dateConfigMap2 = {
    year: {
      format: "YYYY",
      caption: "سال",
      step: 1,
    },
    month: {
      format: "M",
      caption: "ماه",
      step: 1,
    },
    date: {
      format: "D",
      caption: "روز",
      step: 1,
    },
  };

  const handleSelect = (time) => {
    setTime(time);
    setState({
      ...state,
      dateValue: time.jy + "/" + time.jm + "/" + time.jd,
      statusdatepicker: false,
      dropdownClass: true,
    });
  };

  const handleCancel = () => {
    setState({
      ...state,
      statusdatepicker: false,
      dropdownClass: !(state.dateValue.length == 0),
    });
  };

  const closePopup = () => {
    if (state.popupType == 1) {
      setState({
        ...state,
        popupStatus: false,
      });
      props.history.go(-2);
    } else {
      props.history.goBack();
    }
  };

  const submitForm = () => {
    if (
      state.name.length >= 3 &&
      state.lastName.length > 3 &&
      state.nationalCode.length == 10 &&
      state.dateValue.length !== 0 &&
      state.email.length > 5
    ) {
      setState({
        ...state,
        loader: true,
      });
      if (state.imgUrl.length == 0) {
        let data = {
          name: state.name,
          last_name: state.lastName,
          national_code: state.nationalCode,
          birthdate: state.dateValue,
          email: state.email,
        };

        base_url
          .post(`update_profile`, data)
          .then((response) => {
            console.log(response.data);
            if (response.data.success == 1) {
              setState({
                ...state,
                textApi: "اطلاعات شما با موفقیت بروزرسانی شد.",
                popupStatus: true,
                loader: false,
              });
            } else {
              setState({
                ...state,
                textApi: "مشکلی بوجود آمد لطفا دوباره سعی نکنید.",
                popupStatus: true,
                loader: false,
              });
            }
          })
          .catch((error) => {
            if (error.response != undefined) {
              console.log(error);
              if (error.response.status == 401) {
                props.history.push(`/Entrance`);
              } else {
                setState({
                  ...state,
                  textApi:
                    "مشکلی در سرور رخ داده است لطفا بعداز چند دقیقه دوباره سعی کنید",
                  popupStatus: true,
                  popupType: 2,
                  loader: false,
                });
              }
            }
          });
      } else {
        const formData = new FormData();
        formData.append("photo", document.getElementById("file").files[0]);
        console.log(formData.get("file"));
        base_url
          .post(`update_profile_photo`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let dataSecond = {
              name: state.name,
              last_name: state.lastName,
              national_code: state.nationalCode,
              birthdate: state.dateValue,
              email: state.email,
              photo: response.data.profile_photo_url,
            };

            base_url
              .post(`update_profile`, dataSecond)
              .then((resp) => {
                console.log(resp.data.ticketcategories);
                setState({
                  ...state,
                  textApi: "اطلاعات شما با موفقیت بروزرسانی شد.",
                  popupStatus: true,
                  popupType: 1,
                  loader: false,
                });
              })
              .catch((error) => {
                if (error.response != undefined) {
                  console.log(error);
                  if (error.response.status == 401) {
                    props.history.push(`/Entrance`);
                  } else {
                    setState({
                      ...state,
                      textApi:
                        "مشکلی در سرور رخ داده است لطفا بعداز چند دقیقه دوباره سعی کنید",
                      popupStatus: true,
                      popupType: 2,
                      loader: false,
                    });
                  }
                }
              });
          })
          .catch((error) => {
            if (error.response != undefined) {
              console.log(error);
              if (error.response.status == 401) {
                props.history.push(`/Entrance`);
              } else {
                setState({
                  ...state,
                  textApi:
                    "مشکلی در سرور رخ داده است لطفا بعداز چند دقیقه دوباره سعی کنید",
                  popupStatus: true,
                  popupType: 2,
                  loader: false,
                });
              }
            }
          });
      }
    } else {
      setState({
        ...state,
        validInput: true,
      });
    }
  };

  return (
    <React.Fragment>
      <Loader active={state.loader} />
      <div
        className={`instructpg edit-personalinfo ${
          state.animToggle ? "" : "active"
        }`}
      >
        <Header innerPage={true} title={"اطلاعات شخصی"} />

        <Popup active={state.popupStatus}>
          <h4>{state.textApi}</h4>
          <div className="btn-base btn-black btn-sircle">
            <Button variant="contained" onClick={closePopup}>
              {state.popupType == 1 ? "تایید" : "خروج"}
            </Button>
          </div>
        </Popup>

        <div className="body-edit">
          <div
            className={`pic-upload ${
              state.imgUrl.length == 0 ? "slct-img" : ""
            }`}
          >
            <div className="input-select">
              <Button variant="contained" onClick={closeBottomSheet}>
                <i className="icon-photo-camera"></i>
              </Button>
            </div>
            <div className="selected-pic">
              <img
                id="output"
                src=""
                onError={(e) => (e.currentTarget.src = state.imgPlaceholder)}
              />
            </div>
          </div>

          <div className="input-form">
            <TextField
              id="name"
              label="نام"
              value={state.name}
              onChange={(e) => handleInput(e, "name")}
            />
            <span
              className={`error-respns ${
                state.name.length < 3 && state.validInput ? "active" : ""
              }`}
            >
              <i className="icon-exclamation-mark"></i>
              نام خود را کامل وارد کنید
            </span>
          </div>
          <div className="input-form">
            <TextField
              id="lastName"
              label="نام خانوادگی"
              value={state.lastName}
              onChange={(e) => handleInput(e, "lastName")}
            />
            <span
              className={`error-respns ${
                state.lastName.length <= 3 && state.validInput ? "active" : ""
              }`}
            >
              <i className="icon-exclamation-mark"></i>
              نام خانوادگی خود را کامل وارد کنید
            </span>
          </div>
          <div className="input-form">
            <TextField
              id="nationalCode"
              label="کد ملی"
              value={state.nationalCode}
              onChange={(e) => handleInput(e, "nationalCode")}
              onInput={(e) => {
                if (!/^\d+$/.test(e.target.value)) {
                  e.target.value = e.target.value.slice(
                    0,
                    e.target.value.length - 1
                  );
                }
                e.target.value = e.target.value.slice(0, 10);
              }}
            />
            <span
              className={`error-respns ${
                state.nationalCode.length !== 10 && state.validInput
                  ? "active"
                  : ""
              }`}
            >
              <i className="icon-exclamation-mark"></i>
              کد ملی خود را کامل وارد کنید
            </span>
          </div>

          <div className="input-form" onClick={toggleDatePicker}>
            <div
              className={`dropdown-customs ${
                state.dropdownClass ? "active" : ""
              }`}
            >
              <span>تاریخ تولد</span>
              <strong>{state.dateValue}</strong>
              <i className="icon-calendar-1"></i>
            </div>
            <span
              className={`error-respns ${
                state.dateValue.length == 0 && state.validInput ? "active" : ""
              }`}
            >
              <i className="icon-exclamation-mark"></i>
              تاریخ تولد خود را انتخاب کنید
            </span>
          </div>

          <div className="input-form">
            <TextField
              id="email"
              label="ایمیل"
              value={state.email}
              onChange={(e) => handleInput(e, "email")}
            />
            <span
              className={`error-respns ${
                state.email.length < 5 && state.validInput ? "active" : ""
              }`}
            >
              <i className="icon-exclamation-mark"></i>
              تاریخ تولد خود را انتخاب کنید
            </span>
          </div>
        </div>
        <div className="btn-base btn-black btn-sircle">
          <Button variant="contained" onClick={submitForm}>
            ذخیره
          </Button>
        </div>

        <DatePicker
          value={time}
          isOpen={state.statusdatepicker}
          onSelect={handleSelect}
          onCancel={handleCancel}
          dateConfig={dateConfigMap2}
          confirmText="تایید"
          customHeader="تاریخ تولد"
          cancelText="لغو"
        />

        <div className="btm-sht">
          <SwipeableBottomSheet
            open={state.statusBottomSheet}
            onChange={() => closeBottomSheet()}
            overflowHeight={0}
          >
            <div style={{ height: "auto" }} className="bottom-sheet">
              <h4>تغییر عکس پروفایل</h4>
              <Button variant="contained">
                <form className="input-select" id="form">
                  <input
                    type="file"
                    accept="image/*"
                    name="photo"
                    id="file"
                    onChange={(event) => loadFile(event)}
                  />
                </form>
                <b>انتخاب از گالری</b>
              </Button>
              <Button variant="contained" onClick={deletePictuer}>
                حذف عکس
              </Button>
            </div>
          </SwipeableBottomSheet>
        </div>
      </div>
    </React.Fragment>
  );
};

export default EditPersonalInfo;
